import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { webUI, webUIBaseUrl } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const privateLibraryService = createApi({
  reducerPath: "privateLibraryService",
  baseQuery: fetchBaseQuery({ baseUrl: webUIBaseUrl }),
  tagTypes: ["privateLibrary"],
  endpoints: (builder) => ({
    getLibraryByCategoryId: builder.mutation({
      query(body) {
        console.log(body, "body");
        return {
          url: `${webUI.privateLibraryController.getLibraryByCategoryId}/category/${body.libraryCategoryId}?userId=${body.userId}&page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    buyPrivateDharmaLibrary: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.buyPrivateDharmaLibrary}`,
          method: "POST",
          body: body,
        };
      },
    }),
    getLibrarayBySearch: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getLibrarayBySearch}`,
          method: "POST",
          body: body.payload,
           headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    uploadPdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.upload}?libraryCategoryId=${body.libraryCategoryId}&tokenCount=${body.tokenCount}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.file,
        };
      },
    }),
    deletePdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.deletePdf}/${body.id}`,
          method: "DELETE",
        };
      },
    }),
    getLibraryById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getLibraryById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    downloadPdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.downloadPdf}/${body.recordId}/download`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    logReadingTime: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.logReadingTime}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getAllPdfUsageLogsWithPagination: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getAllPdfUsageLogsWithPagination}?page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deletePdfUsageById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.deletePdfUsageById}/${body.id}`,
          method: "DELETE",
        };
      },
    }),

    getAllPdfUsageLogsWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getAllPdfUsageLogsWithSearch}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
  }),
});
export const {
  useGetLibraryByCategoryIdMutation,
  useGetLibraryByIdMutation,
  useUploadPdfMutation,
  useDownloadPdfMutation,
  useDeletePdfMutation,
  useLogReadingTimeMutation,
  useGetAllPdfUsageLogsWithPaginationMutation,
  useDeletePdfUsageByIdMutation,
  useGetAllPdfUsageLogsWithSearchMutation,
  useBuyPrivateDharmaLibraryMutation,
  useGetLibrarayBySearchMutation
} = privateLibraryService;
